<div class="form-container">
  <div class="form-header">
    <h1>{{ 'project_step_project_title' | translate }}</h1>
    <p class="required-note">{{ 'project_required_fields_note' | translate }}</p>
  </div>

  <form [formGroup]="projectForm" (ngSubmit)="handleSubmit()">
    <div class="form-content">
      <div class="form-section" *ngIf="projectId">
        <div class="form-row">
          <mat-form-field appearance="outline" style="flex: 0 0 25%">
            <mat-label>{{ 'project_field_creation_date_label' | translate }}</mat-label>
            <input matInput disabled [value]="projectForm.value.createDate | localizedDate: 'shortDate'" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="flex: 0 0 25%">
            <mat-label>{{ 'project_field_last_modified_date_label' | translate }}</mat-label>
            <input matInput disabled [value]="projectForm.value.updateDate | localizedDate: 'shortDate'" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="flex: 1">
            <mat-label>{{ 'project_field_owner_entity' | translate }}</mat-label>
            <input matInput disabled [value]="projectForm.value.owner" />
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" style="flex: 0 0 25%">
            <mat-label>{{ 'project_field_created_by' | translate }}</mat-label>
            <input matInput disabled [value]="projectForm.value.creator" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="flex: 0 0 25%">
            <mat-label>{{ 'project_field_modified_by_label' | translate }}</mat-label>
            <input matInput disabled [value]="projectForm.value.modifier" />
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <div class="form-row">
          <mat-form-field appearance="outline" style="flex: 0 0 25%">
            <mat-label>{{ 'project_field_code_label' | translate }}</mat-label>
            <input matInput formControlName="code" maxlength="10" placeholder="SERCE1234" />
            <mat-hint align="end">{{ projectForm.value.code?.length || 0 }} / 10</mat-hint>
            <mat-error *ngIf="formCrls.code.invalid">{{ 'project_field_code_required' | translate }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_displayname_label' | translate }}</mat-label>
            <input matInput formControlName="displayName" maxlength="100" [placeholder]="'project_field_displayname_placeholder' | translate" />
            <mat-hint align="end">{{ projectForm.value.displayName?.length || 0 }} / 100</mat-hint>
            <mat-error *ngIf="formCrls.displayName.invalid">{{ 'project_field_displayname_required' | translate }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_title_label' | translate }}</mat-label>
            <input matInput formControlName="title1" maxlength="100" [placeholder]="'project_field_title_placeholder' | translate" />
            <mat-hint align="end">{{ projectForm.value.title1?.length || 0 }} / 100</mat-hint>
            <mat-error *ngIf="formCrls.title1.invalid">{{ 'project_field_title_required' | translate }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_project_nature_label' | translate }}</mat-label>
            <mat-select formControlName="projectType" [multiple]="true" [compareWith]="compareProjectTypes">
              <mat-option *ngFor="let type of projectTypes" [value]="type">
                {{ type.displayName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formCrls.projectType.invalid">{{ 'project_field_project_nature_required' | translate }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" style="flex: 1">
            <mat-label>{{ 'project_field_database_label' | translate }}</mat-label>
            <mat-select formControlName="versionId">
              <mat-option *ngFor="let db of databases" [value]="db.versionId">
                {{ db.versionName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formCrls.versionId.invalid">{{ 'project_field_database_required' | translate }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="flex: 1">
            <mat-label>{{ 'project_field_contractor_label' | translate }}</mat-label>
            <input
              matInput
              formControlName="projectContractorObject"
              maxlength="100"
              [matAutocomplete]="autoContractor"
              [matAutocompleteDisabled]="isFromCallForTenders"
              [readonly]="isFromCallForTenders"
              [placeholder]="'project_field_contractor_placeholder' | translate" />
            <mat-autocomplete #autoContractor="matAutocomplete" [displayWith]="displayContractorName">
              <mat-option *ngFor="let contractor of filteredContractors | async" [value]="contractor">
                {{ contractor.displayName }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint align="end">{{ getMoaLength() }} / 100</mat-hint>
            <mat-error *ngIf="formCrls.projectContractorObject.invalid">{{ 'project_field_contractor_required' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-section optional-section">
        <div class="form-grid-2x3">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_customer_ref_label' | translate }}</mat-label>
            <input matInput formControlName="customerRef" maxlength="20" [placeholder]="'project_placeholder_enter_value' | translate" />
            <mat-hint align="end">{{ projectForm.value.customerRef?.length || 0 }} / 20</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_moa_complement_label' | translate }}</mat-label>
            <input matInput formControlName="moaComplement" [placeholder]="'project_placeholder_enter_value' | translate" />
          </mat-form-field>
          <ng-container *ngIf="projectId">
            <div class="logo-upload-wrapper" *ngFor="let logo of logos">
              <label class="logo-upload-label">{{ logo.labelKey | translate }}</label>
              <div class="justificatif" *ngIf="!currentProject?.[logo.property]">
                <input [id]="logo.field" type="file" #logoInput class="inputfile" accept="image/png, image/jpg, image/jpeg" (change)="uploadLogo(logo, logoInput.files)" />
                <button mat-mini-fab color="accent" class="mini-fab" type="button" (click)="logoInput.click()">
                  <mat-icon>add</mat-icon>
                </button>
                <label [for]="logo.field">{{ 'project_logo_add' | translate }}</label>
              </div>
              <div *ngIf="currentProject?.[logo.property]" class="logo">
                <a class="img-logo" [href]="getLogoUrl(logo.property)" [title]="getLogoFileName(logo.property)" target="_blank" rel="noopener">{{ getLogoFileName(logo.property) }}</a>
                <mat-icon class="delete-icon" (click)="deleteLogo(logo.property)" color="warn">delete_outline</mat-icon>
              </div>
            </div>
          </ng-container>
          <div class="checkbox-wrapper">
            <mat-checkbox formControlName="useWaterAndBiodeversityIndicators"> {{ 'project_field_water_biodiversity_indicators' | translate }} </mat-checkbox>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_project_status_label' | translate }}</mat-label>
            <mat-select formControlName="state">
              <mat-option *ngFor="let status of projectStatuses" [value]="status.value">
                {{ status.labelKey | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_offer_date_label' | translate }}</mat-label>
            <input matInput [matDatepicker]="offerDatePicker" formControlName="offerSubmissionDate" />
            <mat-datepicker-toggle matSuffix [for]="offerDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #offerDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'project_field_report_date_label' | translate }}</mat-label>
            <input matInput [matDatepicker]="reportDatePicker" formControlName="reportTransmissionDate" />
            <mat-datepicker-toggle matSuffix [for]="reportDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #reportDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions" [class.has-create-delete]="!projectId">
        <button mat-stroked-button type="button" class="delete-btn" (click)="handleDelete()" *ngIf="!projectId">
          <mat-icon>delete</mat-icon>
          <span>{{ 'project_btn_delete' | translate }}</span>
        </button>
        <button mat-raised-button type="button" class="submit-btn" [disabled]="!projectForm.valid" (click)="handleSave()" *ngIf="!projectId">
          <span>{{ 'project_btn_create' | translate }}</span>
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>
